// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "reactPlayerPreview" + "." + "dcf6a377" + ".chunk.js";
};